import messageBox from "./messageBox";

// useage:
// this.$messageBox.[alert || confirm](String)
export default {
  install(Vue) {
    Vue.prototype.$messageBox = messageBox;
  }
};
